import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../Seo';
import { seo } from '../../seo/seoData';
import BlockRenderer from './BlockRenderer';
import { findServiceByPath } from '../../navigation/serviceCatalog';
import { BREADCRUMB_LABEL } from '../../navigation/routeRegistry';

// Structural breadcrumb — registry-derived page chrome (NOT a content block). Mirrors the labelling
// of jsonld.buildBreadcrumb: service routes are 3-level (Accueil → Services → {Service}); other
// labelled non-home routes are 2-level. Home / unlabelled routes render no breadcrumb. Internal
// links only — identical href set to the pre-migration hand-rolled service breadcrumb.
function StructuralBreadcrumb({ path }) {
  const service = findServiceByPath(path);
  if (!service && !BREADCRUMB_LABEL[path]) return null;
  const items = [{ name: 'Accueil', to: '/' }];
  if (service) {
    items.push({ name: BREADCRUMB_LABEL['/services'], to: '/services' });
    items.push({ name: service.name, current: true });
  } else {
    items.push({ name: BREADCRUMB_LABEL[path], current: true });
  }
  return (
    <nav aria-label="breadcrumb" className="mb-8 text-sm text-neutral-500">
      {items.map((item, i) => (
        <React.Fragment key={i}>
          {i > 0 ? <span className="mx-2">/</span> : null}
          {item.current ? (
            <span className="text-black">{item.name}</span>
          ) : (
            <Link to={item.to} className="hover:text-black">{item.name}</Link>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
}

// ContentPage — the single generic public-content template. Renders per-route metadata (from the
// single seoData source via <Seo>), the structural breadcrumb, and the page's content blocks. It
// does NOT emit JSON-LD: the global <JsonLd/> (App.js) remains the sole authority via graphForPath.
export default function ContentPage({ seoKey, path, blocks, testId }) {
  const meta = seo[seoKey];
  return (
    <div className="min-h-screen bg-[#f8f8f8]" data-testid={testId}>
      {meta ? <Seo {...meta} /> : null}
      <section className="pt-32 pb-20">
        <div className="max-w-[900px] mx-auto px-6 md:px-12">
          <StructuralBreadcrumb path={path} />
          <BlockRenderer blocks={blocks} />
        </div>
      </section>
    </div>
  );
}
